import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./ListBoard.module.css";
import Header from "./components/Header";
import ListItem from "./components/ListItem";
import BoardIndex from "./components/BoardIndex";
import LinkBtn from "./components/LinkBtn";

export default function ListBoard(props) {
  const { category_id, api, title, postTitle } = props;
  let [data, setData] = useState([]);
  let [page, setPage] = useState(0);
  let [numArticle, setNumArticle] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  let importantCount = 0;

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/api/${api}/articles/count?category_id=${category_id}`
      )
      .then(async (res) => {
        if (res.data.length !== 0) {
          setNumArticle(res.data[0].count);
        }
      });
  }, [location, page]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/api/${api}/articles?category_id=${category_id}&page=${page}&limit=10`
      )
      .then((res) => {
        if (res.data.length !== 0) {
          setData([...res.data]);
          importantCount = 0;
        } else {
          setData([]);
        }
      });
  }, [location, page]);

  const changePage = (page) => {
    setPage(page);
  };

  const move = (n) => {
    navigate(`/${api}/article/${n}`, { state: { category_id: category_id } });
  };

  return (
    <div className={styles.ListBoard}>
      <Header title={title}></Header>
      <div className={styles.ItemContainer}>
        <ListItem isLegend={true} />
        {data.length > 0 ? (
          data.map(
            ({ is_important, id, title, uploaded_at, user_name }, index) => {
              if (is_important == 1) {
                importantCount++;
              }

              return (
                <ListItem
                  id={id}
                  postNum={
                    is_important == 1
                      ? "중요"
                      : numArticle - page * 10 - index + importantCount
                  }
                  title={title}
                  userName={user_name}
                  date={uploaded_at.slice(5, 10)}
                  move={move}
                  key={index}
                />
              );
            }
          )
        ) : (
          <div className={styles.NoArticle}>게시글이 없습니다.</div>
        )}
      </div>
      <div className={styles.ToolDiv}>
        <BoardIndex
          changePage={changePage}
          totalPage={Math.floor(numArticle / 10)}
        />
        {postTitle != undefined ? (
          <LinkBtn to={`/${api}/post`} title={postTitle} />
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}
